/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S10_Li4Inputs */

const tr_mesafeli_s10_li4 = /** @type {(inputs: Mesafeli_S10_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sağlayıcı, anahtarların pazaryeri tarafında doğurabileceği işlemlerden sorumlu değildir; anahtarlar her zaman Müşteri'nin kontrolündedir.`)
};

const en_mesafeli_s10_li4 = /** @type {(inputs: Mesafeli_S10_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Provider is not liable for transactions that the keys may trigger on the marketplace side; the keys are always under the Customer's control.`)
};

const de_mesafeli_s10_li4 = /** @type {(inputs: Mesafeli_S10_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Anbieter haftet nicht für Vorgänge, die die Schlüssel auf Seiten des Marktplatzes auslösen können; die Schlüssel stehen jederzeit unter der Kontrolle des Kunden.`)
};

const ru_mesafeli_s10_li4 = /** @type {(inputs: Mesafeli_S10_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщик не несёт ответственности за операции, которые ключи могут вызвать на стороне маркетплейса; ключи всегда находятся под контролем Клиента.`)
};

/**
* | output |
* | --- |
* | "The Provider is not liable for transactions that the keys may trigger on the marketplace side; the keys are always under the Customer's control." |
*
* @param {Mesafeli_S10_Li4Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s10_li4 = /** @type {((inputs?: Mesafeli_S10_Li4Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S10_Li4Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s10_li4(inputs)
	if (locale === "de") return de_mesafeli_s10_li4(inputs)
	if (locale === "ru") return ru_mesafeli_s10_li4(inputs)
	return tr_mesafeli_s10_li4(inputs)
});